import LegalEntity from 'modules/core/store/models/LegalEntity'

import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'

const FRANCE_FIELDS = ['iban', 'seniority', 'payslip_by_post']
const SPAIN_FIELDS = ['iban', 'social_security_number', 'irpf']

const MEXICO_FIELDS = [
  'rfc',
  'clabe',
  'imss_number',
  'curp',
  'bank',
  'bank_account',
  'imss_start_date',
  'payment_method',
  'geographic_area',
]

const FIELDS_SET = new Set([...FRANCE_FIELDS, ...SPAIN_FIELDS, ...MEXICO_FIELDS])

const FIELDS_BY_LEGAL_ENTITY = Array.from(FIELDS_SET)

const showByLegalEntity = (resourceField: ResourceField): boolean => {
  return FIELDS_BY_LEGAL_ENTITY.includes(resourceField.attributes.identifier)
}

const filterByLegalEntity = (legalEntity: LegalEntity, resourceField: ResourceField): boolean => {
  const identifier = resourceField.attributes.identifier

  switch (legalEntity.country) {
    case LegalEntity.countryDefaults.es:
      return SPAIN_FIELDS.includes(identifier)

    case LegalEntity.countryDefaults.fr:
      return FRANCE_FIELDS.includes(identifier)

    case LegalEntity.countryDefaults.mx:
      return MEXICO_FIELDS.includes(identifier)

    default:
      return false
  }
}

export const legalEntityCustomFieldFilter =
  (legalEntity: LegalEntity) =>
  (models: ResourceField[]): ResourceField[] => {
    return models.filter((model) => {
      if (!showByLegalEntity(model)) return true

      return filterByLegalEntity(legalEntity, model)
    })
  }
